import React from 'react';
import './ChatMessages.scss';

interface ChatMessageProps {
  userName: string;
  message: string;
  isCurrentUser?: boolean
}

const ChatMessage = ({ userName, message, isCurrentUser}: ChatMessageProps) => {
  
  return (
    <div className={`chat-message ${isCurrentUser ? 'sent' : 'received'}`}>
      <div className="chat-message-user">
        {userName}
      </div>
      <div className="chat-message-text">
        {message}
      </div>
    </div>
  );
}

export default ChatMessage;
